import React from 'react';

import SwirlsDesktop from '../../../assets/swirl_illustrations/variant_container/desktop.svg';
import SwirlsMobile from '../../../assets/swirl_illustrations/variant_container/mobile.svg';

import './style.scss';

const SwirlIllustrationsContainer: React.FC = () => (
  <div className="SwirlIllustrations--Container">
    <img
      src={SwirlsMobile}
      className="SwirlIllustrations--Container__swirl SwirlIllustrations--Container__swirl__mobile"
      alt=""
    />
    <img
      src={SwirlsDesktop}
      className="SwirlIllustrations--Container__swirl SwirlIllustrations--Container__swirl__desktop"
      alt=""
    />
  </div>
);

export default SwirlIllustrationsContainer;
